import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit
} from '@angular/core';

import {
  Edit,
  EditContext,
  getSVGViewBox
} from '../assets';

@Component({
  selector: 'kyc-icon-edit',
  template: Edit.svg,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditComponent implements SVG2TSDynamic, OnInit {
  public static UUID = 0;
  public baseUrl: string;
  @Input() public height: number | string = Edit.height;
  @Input() public viewBox: string = getSVGViewBox(Edit.viewBox);
  @Input() public width: number | string = Edit.width;
  @Input()
  public set context(ctx: EditContext) {
    this.updateContext(ctx);
  }
  public get context() {
    return this._context;
  }

  private _context: EditContext = Edit.contextDefaults;

  constructor(private _ref: ChangeDetectorRef) {}


  public getURLBase(value: string) {
    return `url('${this.getXlinkBase(value)}')`;
  }

  public getXlinkBase(value: string) {
    return `${this.baseUrl}${value}`;
  }

  public ngOnInit() {
    this.baseUrl = window.location.href.replace(window.location.hash, '');
    this.context.uuid = EditComponent.UUID++;
  }

  public updateContext(ctx: any) {
    this._context = Object.assign({}, this._context ? this._context : Edit.contextDefaults, ctx);
    this._ref.markForCheck();
  }
}
